import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import useMain from '../../hooks/useMain';
import http from '../../services/httpService';
import Preloader from './../common/preloader';
import BlogCard from './blogs/blogCard';

function Blogs(props) {
	useDocumentTitle(['Blogs']);
	const { blogs, userData, onRemoveBlog, onUserDataChanged } = useMain();
	const [isLoading, setIsLoading] = useState(false);

	const handleDelete = async (_id) => {
		try {
			setIsLoading(true);
			const { data } = await http.deleteBlog({ _id });
			toast.success(data.message);
			onRemoveBlog(_id);
			onUserDataChanged({ blogs: data.blogs });
		} catch (ex) {
			console.log(ex);
			if (ex.response && ex.response.data) toast.error(ex.response.data);
		} finally {
			setIsLoading(false);
		}
	};

	if (!blogs || !userData._id) return <Preloader />;
	return (
		<div className='container my-4'>
			<div className='row gy-5'>
				<div className='col-12'>
					<div className='fw-bold fs-4 text-center'>Weblogs</div>
				</div>
				<div className='col-12'>
					<Link
						to='/blogs/create'
						className='btn btn-set2-light'>
						<i className='me-2 fas fa-plus'></i>New Blog
					</Link>
				</div>

				{blogs
					.sort((a, b) => (a.date > b.date ? -1 : 1))
					.map((b, key) => (
						<div
							key={key}
							className='col-sm-3 mb-4'>
							<BlogCard
								isLoading={isLoading}
								onDelete={handleDelete}
								{...props}
								blog={b}
							/>
						</div>
					))}
			</div>
		</div>
	);
}

export default Blogs;
